import React, { useEffect, useState } from 'react'
import sanityClient from '../client.js'

const Projects = () => {
	const [projectData, setProjectData] = useState(null)

	useEffect(() => {
		sanityClient
			.fetch(
				`*[_type =='project']{
			title,
			date,
			place,
			description,
			image{
				asset->{
					_id,
					url
				},
				alt
			},
			projectType,
			link,
			tags
		}`
			)
			.then((data) => setProjectData(data))
			.catch(console.error)
	}, [])

	return (
		<main className='bg-primary-200 min-h-screen p-12'>
			<section className='container mx-auto'>
				<h1 className='text-5xl flex justify-center cursive'>Projects</h1>
				<h2 className='text-lg text-gray-800 flex justify-center mt-2 mb-12'>
					Here are a selection of our projects, enjoy!
				</h2>
				<section className='grid grid-cols-1 md:grid-cols-2 gap-8'>
					{projectData &&
						projectData.map((project, index) => {
							return (
								<article
									key={index}
									className='relative rounded-lg shadow-xl bg-white p-8'>
									<div className='border-t border-b grid sm:grid-cols-2 mb-4'>
										<h3 className='font-bold  md:text-2xl  lg:text-3xl text-primary-900 hover:text-secondary-600 '>
											<a
												href={project.link}
												alt={project.title}
												target='_blank'
												rel='noopener noreferrer'>
												{project.title}
											</a>
										</h3>
										{project.image && (
											<img
												src={project.image.asset.url}
												alt={project.image.alt}
												className=''
											/>
										)}
									</div>
									<div className='text-gray-800 text-xs'>
										<div>
											<strong className='font-bold'>Finished on:</strong>{' '}
											{new Date(project.date).toLocaleDateString()}
										</div>
										<div className='flex justify-between'>
											<div>
												<strong className='font-bold'>Company:</strong>{' '}
												{project.place}
											</div>
											<div>
												<strong className='font-bold'>Type:</strong>{' '}
												{project.projectType}
											</div>
										</div>
										<p className='text-primary-500 text-lg my-6 leading-relaxed'>
											{project.description}
										</p>
										<div className='flex justify-center'>
											<a
												className='text-secondary-200 bg-secondary-900 p-4 hover:bg-primary-900 hover:text-primary-200 uppercase rounded'
												href={project.link}
												alt={project.title}
												target='_blank'
												rel='noopener noreferrer'>
												View the project
											</a>
										</div>
									</div>
								</article>
							)
						})}
				</section>
			</section>
		</main>
	)
}

export default Projects
